import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import { defaultTabs,TabKeyEnum, SubTypeEnum, IStmxGroup } from "ngx-exdr-stmx-common";
// import { AuthService } from "../services/auth.service";


import { MetaService, AddonType, IStmxHost } from "ngx-exdr-stmx-common";
import { TabOrderData } from "../models/tab-order.model";
import { TabsManagementService } from "../../layout/services/tabs-management.service";


@Injectable({ providedIn: 'root' })
export class TabMetaDataResolver implements Resolve<any>{

    constructor(private tabManagementService: TabsManagementService, private metaService: MetaService, 
        private IStmxHostService: IStmxHost,
        private labelService: IStmxGroup,
        // TODO 10July
        // private authService: AuthService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return forkJoin({addons: this.IStmxHostService.getAddons(), tabs: this.tabManagementService.getHeaderTabs()}).pipe(
            map((response) => {
                const addons = response.addons;
                const tabs = response.tabs;

                let metaTitle = '';
                let metaDescription = '';
                let banner;
                const tabKey = route.data.tabKey;
                const tabSlug = route.params?.slug;
                const tabId = route.queryParams?.tabId;
                const customTabSuffix = route.params?.postFix;
                let tabKeyId = null;
                let tabBasePath = this.getTabBasePath(tabKey, tabSlug, customTabSuffix)

                if (tabId || tabSlug) {
                    const addon = addons.find(t => {
                        if (tabSlug) {
                            return t?.PublicProperties?.urlName == tabSlug ||
                                (t?.PublicProperties?.subtype == SubTypeEnum.TOPIC && t?.PublicProperties?.slug == tabSlug)
                        } else {
                            return t.InstanceId == tabId
                        }
                    });
                    tabKeyId = 'custom tab' + addon?.InstanceId;
                    metaTitle = addon?.PublicProperties?.metaTitle ?? null;
                    metaDescription = addon?.PublicProperties?.metaDescription ?? null;
                    banner = addon?.PublicProperties?.bannerData ?? null;
                    if (addon && addon?.PublicProperties?.subtype !== SubTypeEnum.IFRAME &&
                        addon?.PublicProperties?.subtype !== SubTypeEnum.WEB_LINK && addon?.PublicProperties?.subtype !== SubTypeEnum.REQUEST
                        && addon?.PublicProperties?.subtype !== SubTypeEnum.RequestCatalog) {
                        if (banner) {
                            banner.tabTitle$ = this.labelService.getTabTranslation(tabId);
                        }
                        else {
                            banner = { tabTitle$: this.labelService.getTabTranslation(tabId) }
                        }
                    }

                }
                else if (tabKey) {
                    tabKeyId = tabKey;
                    if (tabKey == TabKeyEnum.Home) {
                        const homeAddon = addons.find(t => t.PublicProperties?.isLandingPageTab);
                        metaTitle = homeAddon?.PublicProperties?.metaTitle ?? null;
                        metaDescription = homeAddon?.PublicProperties?.metaDescription ?? null;
                        banner = homeAddon?.PublicProperties?.bannerData ?? null;
                    } else {
                        let tab: TabOrderData = null;

                        const tabOrderAddon = addons.find(t => t.Type == AddonType.TabOrder);
                        if (tabOrderAddon) {
                            const tabData = this.safeJsonObject(tabOrderAddon?.PublicProperties?.jsonData);
                            const tabs = (tabData?.data || []).concat(tabData?.utilities || []).concat(tabData?.utilitiesText || []);
                            tab = tabs.find(d => d.key == tabKey);
                        }
                        if (!tab) {                            
                            //let tabs = this.tabManagementService.getHeaderTabs().toPromise();
                            tab =  tabs.find(t => t.key === tabKey); 
                        }
                        metaTitle = tab?.metaTitle ?? null;
                        metaDescription = tab?.metaDescription ?? null;
                        banner = tab?.bannerData ?? null;
                    }
                    if (banner) {
                        banner.tabTitle$ = this.labelService.getTabTranslation(tabKey);
                        banner.tabKey = tabKey;
                    }
                    else {
                        banner = { tabTitle$: this.labelService.getTabTranslation(tabKey), tabKey: tabKey }
                    }

                }
                return {
                    metaTitle,
                    metaDescription,
                    banner,
                    tabBasePath,
                    tabKeyId
                };
            }),
        )
    }

    getTabBasePath(tabKey?: string, tabSlug?: string, customTabSuffix?: string) {
        let basePath;
        let libPath;
        if (tabKey) {
            // libPath =  tabs.find(t => t.key === tabKey); 
            // basePath = libPath?.path;
            // if(!basePath){
            //     basePath = libPath?.data?.url;
            // }
            libPath =  defaultTabs[tabKey];             
            basePath = '/'+libPath                        
        }
        else if (tabSlug) {
            basePath = `/${tabSlug}${customTabSuffix ?? ''}`;
        }
        return basePath;
    }
    safeJsonObject(data: any): any{
        let parsed = {};
        try {
          parsed = JSON.parse(data);
        }
        catch (e) {
          parsed = {};
        }
        return parsed;
    }
}